import * as React from 'react';
export const UMSvg = React.forwardRef(function UMSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#E25950',
      d: 'M14 14H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F6F9FC',
      d: 'M0 3.091h16v1.091H0zm0 2.182h16v1.091H0zm0 2.182h16v1.091H0zm0 2.181h16v1.091H0zm0 2.182h16v1.091H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#E25950',
      d: 'M14 14H2a2 2 0 0 1-2-2V8.5h1V12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H8V2h6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z',
      opacity: 0.1,
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#43458B',
      d: 'M0 8.55V3.871C0 2.838.796 2 1.778 2H8v6.55H0Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      fillRule: 'evenodd',
      d: 'M1.482 2a.5.5 0 1 1 .036 1 .5.5 0 0 1-.036-1Zm2 0a.5.5 0 1 1 .036 1 .5.5 0 0 1-.036-1Zm2 0a.5.5 0 1 1 .036 1 .5.5 0 0 1-.036-1Zm2 0a.5.5 0 1 1 .036 1 .5.5 0 0 1-.036-1Zm-7 1.11a.5.5 0 1 1 .036 1 .5.5 0 0 1-.036-1Z',
      clipRule: 'evenodd',
      opacity: 0.5,
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'M3 3.61a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm2 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm2 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM1.519 5.22a.5.5 0 1 1-.038-1 .5.5 0 0 1 .038 1Zm2 0a.5.5 0 1 1-.038-1 .5.5 0 0 1 .038 1Zm2 0a.5.5 0 1 1-.038-1 .5.5 0 0 1 .038 1Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      fillRule: 'evenodd',
      d: 'M7.482 4.22a.5.5 0 1 1 .036 1 .5.5 0 0 1-.036-1Zm-7 1.11a.5.5 0 1 1 .036 1 .5.5 0 0 1-.036-1Z',
      clipRule: 'evenodd',
      opacity: 0.5,
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'M3 5.83a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm2 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm2 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-5.518.61a.5.5 0 1 1 .036 1 .5.5 0 0 1-.036-1Zm2 0a.5.5 0 1 1 .036 1 .5.5 0 0 1-.036-1Zm2 0a.5.5 0 1 1 .036 1 .5.5 0 0 1-.036-1Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      fillRule: 'evenodd',
      d: 'M7.482 6.44a.5.5 0 1 1 .036 1 .5.5 0 0 1-.036-1Zm-7 1.11a.5.5 0 1 1 .036 1 .5.5 0 0 1-.036-1Zm2 0a.5.5 0 1 1 .036 1 .5.5 0 0 1-.036-1Zm2 0a.5.5 0 1 1 .036 1 .5.5 0 0 1-.036-1Zm2 0a.5.5 0 1 1 .036 1 .5.5 0 0 1-.036-1Z',
      clipRule: 'evenodd',
      opacity: 0.5,
    }),
  );
});
UMSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var UM = {
  category: 'flag',
  colorable: false,
  name: 'UM',
  svg: UMSvg,
};
